var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavetime1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1043_4879)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 64,
    height: 64,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1429 34.0831H28.5714C28.42 34.0835 28.2749 34.1462 28.1679 34.2573C28.0608 34.3684 28.0005 34.519 28 34.6761V46.5602C28.0005 46.7174 28.0608 46.8679 28.1679 46.9791C28.2749 47.0902 28.42 47.1528 28.5714 47.1533H32.1429C32.5949 47.1542 33.0289 46.9695 33.3501 46.6395C33.6713 46.3095 33.8536 45.8609 33.8573 45.3918V35.8623C33.8546 35.3913 33.6731 34.9403 33.3522 34.6073C33.0312 34.2742 32.5968 34.0859 32.1429 34.0831ZM30.9258 38.2346C30.7742 38.2346 30.6289 38.1721 30.5217 38.0609C30.4145 37.9497 30.3543 37.7988 30.3543 37.6415C30.3543 37.4842 30.4145 37.3334 30.5217 37.2222C30.6289 37.1109 30.7742 37.0484 30.9258 37.0484C31.0773 37.0484 31.2227 37.1109 31.3298 37.2222C31.437 37.3334 31.4972 37.4842 31.4972 37.6415C31.4972 37.7988 31.437 37.9497 31.3298 38.0609C31.2227 38.1721 31.0773 38.2346 30.9258 38.2346ZM59.8721 40.8317C59.6803 40.2698 59.2889 39.8051 58.778 39.5328C58.267 39.2605 57.6752 39.2011 57.1234 39.3668L52.2839 40.8258C52.2612 41.8247 51.8629 42.7748 51.1742 43.473C50.4855 44.1712 49.5609 44.5621 48.5981 44.5621H43.2563C43.1047 44.5621 42.9594 44.4996 42.8522 44.3884C42.7451 44.2772 42.6849 44.1264 42.6849 43.9691C42.6849 43.8118 42.7451 43.6609 42.8522 43.5497C42.9594 43.4385 43.1047 43.376 43.2563 43.376H48.5987C51.961 43.2704 51.9702 38.1919 48.5987 38.0798H44.4672C44.1251 38.0812 43.7898 37.9803 43.5014 37.7892C42.1174 36.8824 40.3385 35.4566 38.6048 35.5835H34.9876C34.9933 35.6666 34.999 35.7615 34.999 35.8623V45.3918C34.9979 45.5932 34.9768 45.7939 34.9361 45.9909C35.1196 46.0033 35.2977 46.0602 35.4561 46.1569L39.8677 48.8258C41.0331 49.5318 42.3468 49.9322 43.695 49.9921C45.0432 50.0521 46.3851 49.7698 47.6044 49.1697L58.712 43.7134C59.2151 43.4677 59.6123 43.0368 59.8266 42.5043C60.0409 41.9719 60.0571 41.3758 59.8721 40.8317ZM42.8563 27.4649H41.7363C41.875 29.6132 42.7599 31.6363 44.2268 33.1588C45.6938 34.6813 47.6431 35.5997 49.713 35.7437V34.5812C49.713 34.424 49.7732 34.2731 49.8804 34.1619C49.9875 34.0507 50.1329 33.9882 50.2844 33.9882C50.436 33.9882 50.5813 34.0507 50.6885 34.1619C50.7957 34.2731 50.8559 34.424 50.8559 34.5812V35.7437C52.9257 35.5994 54.8748 34.6808 56.3415 33.1582C57.8082 31.6356 58.6929 29.6125 58.8315 27.4643H57.7114C57.5599 27.4643 57.4145 27.4018 57.3074 27.2906C57.2002 27.1794 57.14 27.0285 57.14 26.8712C57.14 26.714 57.2002 26.5631 57.3074 26.4519C57.4145 26.3407 57.5599 26.2782 57.7114 26.2782H58.8315C58.6927 24.1301 57.8077 22.1072 56.3409 20.5848C54.8741 19.0625 52.925 18.1441 50.8553 18V19.1624C50.8553 19.3197 50.7951 19.4706 50.6879 19.5818C50.5808 19.693 50.4354 19.7555 50.2839 19.7555C50.1323 19.7555 49.987 19.693 49.8798 19.5818C49.7726 19.4706 49.7124 19.3197 49.7124 19.1624V18C47.6425 18.1441 45.6933 19.0627 44.2264 20.5853C42.7596 22.1079 41.8748 24.131 41.7363 26.2794H42.8563C43.0046 26.2842 43.1454 26.3488 43.2486 26.4594C43.3519 26.5701 43.4097 26.7181 43.4097 26.8721C43.4097 27.0262 43.3519 27.1742 43.2486 27.2848C43.1454 27.3955 43.0046 27.46 42.8563 27.4649ZM48.2615 28.1292L49.713 26.6227V22.7203C49.713 22.563 49.7732 22.4122 49.8804 22.3009C49.9875 22.1897 50.1329 22.1272 50.2844 22.1272C50.436 22.1272 50.5813 22.1897 50.6885 22.3009C50.7957 22.4122 50.8559 22.563 50.8559 22.7203V26.8718C50.854 27.0289 50.7948 27.1794 50.6902 27.2929L49.073 28.9713C48.9654 29.083 48.8194 29.1457 48.6673 29.1457C48.5151 29.1457 48.3691 29.083 48.2615 28.9713C48.1539 28.8597 48.0935 28.7082 48.0935 28.5502C48.0935 28.3923 48.1539 28.2408 48.2615 28.1292Z",
    fill: "url(#paint0_linear_1043_4879)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1043_4879",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1043_4879"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1043_4879"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1043_4879"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1043_4879",
    result: "effect2_dropShadow_1043_4879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1043_4879",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1043_4879",
    x1: 28,
    y1: 34,
    x2: 60,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavetime1);
export default __webpack_public_path__ + "static/media/Save time1.5ebf9c8fbffe8029473b36b8b95b51d3.svg";
export { ForwardRef as ReactComponent };